import React from 'react';
import PropTypes from 'prop-types';

export const BrandsThatMatter = ({ children }) => {
  return (<div id="BrandsThatMatter__lander">{children}</div>)
};

BrandsThatMatter.propTypes = {
  children: PropTypes.any
}